import { FieldActionCenter } from "./FieldActionCenter";
import type { DashboardField } from "../types/contract";

// `<main>` is the scrollport, and a sticky box stops at its padding edge, so
// with `top: 0` a strip of rows (`p-3` / `sm:p-4`) would show above the bar.
// The negative top matches the negative margin and the padding paints that
// strip. `z-scrim` is the lowest stacking token, under menus, popovers, and
// dialogs; the panel cards below isolate their own z-scrim badges so they
// can't tie with the bar. Expanded panels are siblings and keep scrolling.
export function FieldActionsRow({ selected }: { selected: DashboardField[] }) {
  return (
    <div className="sticky -top-3 z-scrim -mx-3 -mt-3 bg-canvas px-3 pt-3 sm:-top-4 sm:-mx-4 sm:-mt-4 sm:px-4 sm:pt-4">
      <div className="rounded-lg border border-line bg-raised p-2">
        <div className="flex flex-wrap items-center justify-center gap-2">
          <FieldActionCenter selected={selected} />
        </div>
      </div>
    </div>
  );
}
